const TOKEN_KEY = "ccs_demo_admin_token";
const COMPLAINTS_KEY = "ccs_demo_complaints";

function makeCaseNumber() {
  return `CCS-${new Date().getFullYear()}-${Math.random()
    .toString(36)
    .slice(2, 8)
    .toUpperCase()}`;
}

function readStoredComplaints() {
  try {
    return JSON.parse(localStorage.getItem(COMPLAINTS_KEY) || "[]");
  } catch {
    return [];
  }
}

function saveStoredComplaints(complaints) {
  localStorage.setItem(COMPLAINTS_KEY, JSON.stringify(complaints));
}

async function readJsonResponse(response) {
  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch {
    throw new Error(
      "The Cloudflare API route is not active yet. The dashboard is using local demo storage until the backend is configured."
    );
  }
}

export function getDemoToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setDemoToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearDemoToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function submitComplaint(form) {
  try {
    const response = await fetch("/api/complaints", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(form),
    });

    if (response.ok) {
      return await readJsonResponse(response);
    }
  } catch {
    // Fall through to local demo storage.
  }

  const complaint = {
    id: crypto.randomUUID(),
    case_number: makeCaseNumber(),
    first_name: form.firstName,
    last_name: form.lastName,
    email: form.email,
    phone: form.phone,
    address: form.address,
    category: form.category,
    business_name: form.businessName,
    business_address: form.businessAddress,
    amount_disputed: form.amountDisputed,
    desired_resolution: form.desiredResolution,
    has_contacted_business: form.hasContactedBusiness,
    preferred_contact: form.preferredContact,
    description: form.description,
    status: "new",
    created_at: new Date().toISOString(),
  };

  const complaints = readStoredComplaints();
  saveStoredComplaints([complaint, ...complaints]);

  return {
    ok: true,
    caseNumber: complaint.case_number,
    complaint,
  };
}

export async function getComplaints(token) {
  try {
    const response = await fetch("/api/complaints", {
      headers: {
        authorization: token ? `Bearer ${token}` : "",
      },
    });

    if (response.ok) {
      return await readJsonResponse(response);
    }
  } catch {
    // Fall through to local demo storage.
  }

  return {
    complaints: readStoredComplaints(),
  };
}

export async function askAssistant({
  question,
  issueType = "general consumer issue",
  location = "Cambridge, Massachusetts",
}) {
  const response = await fetch("/api/assistant", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ question, issueType, location }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "The assistant is temporarily unavailable.");
  }

  return data;
}
